export default "__VITE_ASSET__BqQapj_g__"